import {
  Environment,
  initializeEnvironment,
  getEnvironmentName,
} from "./environment-finder";
export type { Environment };
export { initializeEnvironment, getEnvironmentName };

initializeEnvironment();
